module.exports = __webpack_public_path__ + "static/media/psc1.7ac09105.jpg";